import { PortalProductStrategy } from "./portal-product-strategy";
import { ProductKey } from "gast-common-ng2";
import { inject, Injectable } from "@angular/core";
import { PORTAL_DEFAULT_PRODUCT_TOKEN } from "../../../constants";
import { BehaviorSubject, combineLatest, map, Observable, of } from "rxjs";

@Injectable()
export class SinglePortalProductStrategyService extends PortalProductStrategy {
  readonly #defaultAppProduct: ProductKey = inject(PORTAL_DEFAULT_PRODUCT_TOKEN);
  readonly #currentProduct$$ = new BehaviorSubject<ProductKey>(this.#defaultAppProduct);

  readonly availableProducts$: Observable<ProductKey[]> = of<ProductKey[]>([this.#defaultAppProduct]);

  readonly selectedProduct$: Observable<ProductKey> = combineLatest([
    this.availableProducts$,
    this.#currentProduct$$.asObservable(),
  ]).pipe(
    map(([availableProducts, currentProduct]) => {
      const foundProduct: ProductKey | undefined = availableProducts.find((p) => p === currentProduct);
      return foundProduct || currentProduct;
    })
  );

  readonly selectedProductAsString$: Observable<string> = this.selectedProduct$.pipe(
    map((product: ProductKey): string => product.toString())
  );

  readonly availableProductsAsString$: Observable<string[]> = this.availableProducts$.pipe(
    map((products: ProductKey[]): string[] => products.map((product: ProductKey) => product.toString()))
  );

  constructor() {
    super();
    this.subscribeToProductUpdated();
  }

  updateCurrentProduct(productToSet: string): void {
    console.log("Change of the product is not supported for this app config. Trying to set: ", productToSet);
  }
}
